import { Editor } from "slate";
export var isMarkActive = function (editor, format) {
    var marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
};
